<div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim_quick dropdown-menu-top-unround dropdown-menu-xl quick_action_show d-none" x-placement="top-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-200px, 50px, 0px);">
    <form>

        <!--begin: Head -->
        <div class="kt-head kt-head--skin-dark" style="background-image: url(./assets/image/bg-1.jpg)">
            <h3 class="kt-head__title">
                User Quick Actions
                <span class="kt-space-15"></span>
            </h3>
        </div>

        <!--end: Head -->

        <!--begin: Grid Nav -->
        <div class="kt-grid-nav kt-grid-nav--skin-light">
            <div class="kt-grid-nav__row">
                <a href="#" class="kt-grid-nav__item">
                    <span class="kt-grid-nav__icon">
                        <img src="./assets/image/icons/sell_video.png" width="30">
                     </span>
                    <span class="kt-grid-nav__title">Seller Workflow</span>
                    <span class="kt-grid-nav__desc">Watch Video</span>
                </a>
                <a href="#" class="kt-grid-nav__item">
                    <span class="kt-grid-nav__icon">
                         <img src="./assets/image/icons/purchase_video.png" width="30">
                    </span>
                    <span class="kt-grid-nav__title">Purchase Workflow</span>
                    <span class="kt-grid-nav__desc">Watch Video</span>
                </a>
            </div>
            <div class="kt-grid-nav__row">
                <a href="#" class="kt-grid-nav__item">
                    <span class="kt-grid-nav__icon">
                        <img src="./assets/image/icons/user_story.png" width="30">
                    </span>
                    <span class="kt-grid-nav__title">User Stories</span>
                    <span class="kt-grid-nav__desc">Case Study</span>
                </a>
                <a href="https://www.youtube.com/playlist?list=PL0MAH4Rc-sLH9TiYeYB-5UtQ_anEZXqDZ" class="kt-grid-nav__item">
                    <span class="kt-grid-nav__icon">
                        <img src="./assets/image/icons/development_tools.png" width="30">
                    </span>
                    <span class="kt-grid-nav__title">News Feed</span>
                    <span class="kt-grid-nav__desc">Latest Data News</span>
                </a>
            </div>
        </div>

        <!--end: Grid Nav -->
    </form>
</div>